var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('data-table',{attrs:{"url":"ivr/calls","model":"Calls","has-filters":"","date-filter":"true","fields":_vm.fields,"no-modal":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }